var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { ThemeFamilies } from '../../theme/families';
import getThemeBreakpoints from '../../utils/getThemeBreakpoints';
import { ButtonTypography } from '../Typography/button';
import { Elevation } from '../../theme/elevation';
var ButtonGroupElement = function (_a) {
    var staticSize = _a.staticSize, family = _a.family, label = _a.label, name = _a.name, disabled = _a.disabled, isActive = _a.isActive, onClick = _a.onClick, className = _a.className, value = _a.value;
    var handleButtonClick = function (e) {
        if (isActive)
            return;
        onClick(value, e);
    };
    return (_jsx(ButtonGroupOption, __assign({ staticSize: staticSize, className: "button-group-option button-group-option-" + label + " " + (className || ''), family: family, onClick: handleButtonClick, isActive: isActive, name: name, disabled: disabled, "data-testid": name, type: "button" }, { children: label }), void 0));
};
ButtonGroupElement.defaultProps = {
    family: ThemeFamilies.PRIMARY,
};
export default ButtonGroupElement;
var ButtonGroupOption = styled(ButtonTypography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 5px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.5s ease-in;\n  font-family: inherit;\n\n  ", "\n\n  ", ";\n"], ["\n  border-radius: 5px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: background 0.5s ease-in;\n  font-family: inherit;\n\n  ", "\n\n  ",
    ";\n"])), getThemeBreakpoints('buttonGroup'), function (_a) {
    var theme = _a.theme, family = _a.family, isActive = _a.isActive;
    var _b = theme.families.buttonGroupElement[family], main = _b.main, light = _b.light, dark = _b.dark, text = _b.text, selectedText = _b.selectedText, disabledText = _b.disabledText;
    if (isActive) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        box-shadow: ", ";\n        background: ", ";\n        color: ", ";\n      "], ["\n        box-shadow: ", ";\n        background: ", ";\n        color: ", ";\n      "])), function (_a) {
            var theme = _a.theme;
            return theme.elevation[Elevation.DEPTH3];
        }, main, selectedText);
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: transparent;\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n        pointer-events: none;\n      }\n    "], ["\n      background: transparent;\n      color: ", ";\n\n      &:hover {\n        background: ", ";\n        color: ", ";\n      }\n\n      &:disabled {\n        color: ", ";\n        pointer-events: none;\n      }\n    "])), dark, light, text, disabledText);
});
var templateObject_1, templateObject_2, templateObject_3;
